import { Grid, Paper } from '@mui/material'
import React, { } from 'react'
import { HeaderFooterTypographyPDF, PageHeaderPaper } from '../../../../components/CustomStyles/StyledComponents';
import agreCalcLogo from '../../../../assets/images/agrecalc-logo-green.svg'
import dayjs from 'dayjs';

const Header = ({ farmId, farmName, reportId, reportCreated }) => {
    return (
        <header style={{ width: 'inherit' }}>
            <PageHeaderPaper
                sx={{
                    px: 1,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Grid container direction="row">
                    <Grid item xs={5}>
                        <HeaderFooterTypographyPDF
                            paragraph
                            variant="body2"
                            component="div"
                            sx={{ float: 'left', mb: 0 }}
                        >
                            <span className='logo-lg' style={{ margin: '0 auto' }}>
                                <img src={agreCalcLogo} alt='' height='45' />
                            </span>
                        </HeaderFooterTypographyPDF>
                    </Grid>
                    <Grid item xs={5}>
                        <Grid container direction="row" mb={0} >
                            <Grid item xs={4} pr={1}>
                                <HeaderFooterTypographyPDF variant="body2" color='text.secondary'
                                    sx={{ float: 'right' }} mb={0}>
                                    {`Farm name`}
                                </HeaderFooterTypographyPDF>
                            </Grid>
                            <Grid item xs={8} sx={{}}>
                                <HeaderFooterTypographyPDF variant="body2" color='#ababab'
                                    mb={0}>
                                    {farmName}
                                </HeaderFooterTypographyPDF>
                            </Grid>
                        </Grid>
                        <Grid container direction="row" mb={0}>
                            <Grid item xs={4} pr={1}>
                                <HeaderFooterTypographyPDF variant="body2" color='text.secondary'
                                    sx={{ float: 'right' }} mb={0}>
                                    {`Date`}
                                </HeaderFooterTypographyPDF>
                            </Grid>
                            <Grid item xs={8} sx={{}}>
                                <HeaderFooterTypographyPDF variant="body2" color='#ababab'
                                    mb={0}>
                                    {dayjs(reportCreated || new Date()).format('YYYY-MM-DD')}
                                </HeaderFooterTypographyPDF>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={2} >
                        <Grid container direction="row" mb={0} >
                            <Grid item xs={7} pr={1}>
                                <HeaderFooterTypographyPDF variant="body2" color='text.secondary'
                                    sx={{ float: 'right' }} mb={0}>
                                    {`Farm ID`}
                                </HeaderFooterTypographyPDF>
                            </Grid>
                            <Grid item xs={5} sx={{}}>
                                <HeaderFooterTypographyPDF variant="body2" color='#ababab'
                                    mb={0}>
                                    {farmId}
                                </HeaderFooterTypographyPDF>
                            </Grid>
                        </Grid>
                        <Grid container direction="row" mb={0}>
                            <Grid item xs={7} pr={1}>
                                <HeaderFooterTypographyPDF variant="body2" color='text.secondary'
                                    sx={{ float: 'right' }} mb={0}>
                                    {`Report ID`}
                                </HeaderFooterTypographyPDF>
                            </Grid>
                            <Grid item xs={5} sx={{}}>
                                <HeaderFooterTypographyPDF variant="body2" color='#ababab'
                                    mb={0}>
                                    {reportId}
                                </HeaderFooterTypographyPDF>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </PageHeaderPaper>
            <Paper sx={{ height: '5px' }}></Paper>
        </header >
    )
}

export default Header